// src/store/slices/inventoryLogSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import inventoryLogApi from 'api/inventoryLogApi';

export const fetchLogs = createAsyncThunk(
  'inventoryLog/fetchAll',
  async ({ page = 1, pageSize = 10, search = '' }, { rejectWithValue }) => {
    try {
      const res = await inventoryLogApi.getAll(page, pageSize, search);
      return res;
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || 'Failed to load inventory logs');
    }
  }
);

const inventoryLogSlice = createSlice({
  name: 'inventoryLog',
  initialState: {
    logs: [],
    pagination: { count: 0, page_size: 10, next: null, previous: null },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (s) => { s.error = null; },
  },
  extraReducers: (b) => {
    b.addCase(fetchLogs.pending, (s) => { s.isLoading = true; })
      .addCase(fetchLogs.fulfilled, (s, a) => {
        s.isLoading = false;
        s.logs = a.payload.data || [];
        s.pagination = a.payload.pagination || { count: 0, page_size: 10 };
      })
      .addCase(fetchLogs.rejected, (s, a) => {
        s.isLoading = false;
        s.error = a.payload;
      });
  },
});

export const { clearError } = inventoryLogSlice.actions;
export default inventoryLogSlice.reducer;